import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

interface CrmDetailProps {
  id: number;
  onUpdateCompleted?: (id) => void;
}

const useCrmDetail = ({id, onUpdateCompleted}:CrmDetailProps) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [crmInfo, setCrmInfo] = useState<CrmListDto>();

  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.crm.info, location.search],
    () =>
      fetcher.crm.postCrmInfo({id: id}),
    {
      onSuccess: (res: CrmInfoResDto) => {
        switch (res.code) {
          case 200:
            setCrmInfo(res.result?.info);
            break;
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: crmInsert } = useMutation(
    [endpoints.crm.add],
    fetcher.crm.postCrmAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            onUpdateCompleted?.(res.result?.id);
            break;
          case 100:
            message.error("중복된 이름이 존재 합니다.", 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: crmUpdate } = useMutation(
    [endpoints.crm.update],
    fetcher.crm.postCrmUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            onUpdateCompleted?.(id);
            break;
          case 100:
            message.error("중복된 이름이 존재 합니다.", 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: crmDelete } = useMutation(
    [endpoints.crm.delete],
    fetcher.crm.postCrmDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            onUpdateCompleted?.(id);
            break;
          case 100:
            message.error("중복된 이름이 존재 합니다.", 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, crmInfo, crmInsert, crmUpdate, crmDelete  };
};

export default useCrmDetail;
